import { FundCategoryFilters } from '../components/ScreenerFilters/util';
import filters from '../filters.json';

const fundTypeCategories = filters['Fund Type Categories'];

const concatAllLevel3Categories = (level2category) =>
    Object.values(level2category).reduce((prev, curr) => prev.concat(curr));

const directPageFilters = [
    {
        path: 'asset-allocation-funds',
        category: 'asset',
        filters: concatAllLevel3Categories(
            fundTypeCategories['Allocation Funds']
        )
    },
    {
        path: 'aaf',
        category: 'asset',
        filters: concatAllLevel3Categories(
            fundTypeCategories['Allocation Funds']
        )
    },
    {
        path: 'international-stocks',
        category: 'intstocks',
        filters: fundTypeCategories['Stock Funds']['International Equity']
    },
    {
        path: 'money-market-funds',
        category: 'moneymarket',
        filters: concatAllLevel3Categories(
            fundTypeCategories['Money Market Funds']
        )
    },
    {
        path: 'mmfnds',
        category: 'mmfunds',
        filters: concatAllLevel3Categories(
            fundTypeCategories['Money Market Funds']
        )
    },
    {
        path: 'municipal-bond',
        category: 'municipal',
        filters: fundTypeCategories['Bond Funds']['Municipal Bond']
    },
    {
        path: 'sector-equity',
        category: 'sector',
        filters: fundTypeCategories['Stock Funds']['Sector Equity']
    },
    {
        path: 'taxable-bond',
        category: 'taxablebond',
        filters: fundTypeCategories['Bond Funds']['Taxable Bond']
    },
    // not sure what's still relying on the below uri so I left it in
    {
        path: 'us-equity',
        category: 'usequity',
        filters: [
            'Large Blend',
            'Large Growth',
            'Large Value',
            'Mid-Cap Blend',
            'Mid-Cap Growth',
            'Mid-Cap Value',
            'Small Blend',
            'Small Growth'
        ]
    },
    {
        path: 'bond-funds',
        category: 'bonds',
        filters: concatAllLevel3Categories(fundTypeCategories['Bond Funds'])
    },
    {
        path: 'bnfdns',
        category: 'bonds',
        filters: concatAllLevel3Categories(fundTypeCategories['Bond Funds'])
    },
    {
        path: 'stock-funds',
        category: 'allstocks',
        filters: concatAllLevel3Categories(fundTypeCategories['Stock Funds'])
    },
    {
        path: 'iclass-shares',
        category: 'allstocks',
        filters: concatAllLevel3Categories(FundCategoryFilters)
    },
    {
        path: 'iclass',
        category: 'allstocks',
        filters: concatAllLevel3Categories(FundCategoryFilters)
    },
    {
        path: 'closed-funds',
        category: 'allstocks',
        filters: concatAllLevel3Categories(FundCategoryFilters)
    },
    {
        path: 'stfnds',
        category: 'allstocks',
        filters: concatAllLevel3Categories(fundTypeCategories['Stock Funds'])
    },
    {
        path: 'target-date-funds',
        category: 'targetdatefunds',
        filters: concatAllLevel3Categories(
            fundTypeCategories['Target Date Funds']
        )
    },
    {
        path: 'tdf',
        category: 'targetdatefunds',
        filters: concatAllLevel3Categories(
            fundTypeCategories['Target Date Funds']
        )
    },
    {
        path: 'mmfnds',
        category: 'moneymarket',
        filters: concatAllLevel3Categories(
            fundTypeCategories['Money Market Funds']
        )
    },
    {
        path: 'select-funds',
        category: 'selectfunds',
        filters: concatAllLevel3Categories(FundCategoryFilters)
    }
];

const mstarFilter = [
    {
        path: 'morningstar-4-and-5-star-rated-funds',
        filters: ['4- and 5-star Funds']
    },
    {
        path: 'msf',
        filters: ['4- and 5-star Funds']
    }
];

const fundAttributeFilter = [
    {
        path: 'daily-prices',
        filters: ['Investor Class'],
        additionalPills: ['I Class']
    },
    {
        path: 'historical-performance',
        filters: ['Investor Class'],
        additionalPills: ['I Class']
    },
    {
        path: 'stock-funds',
        filters: ['Investor Class'],
        additionalPills: ['I Class']
    },
    {
        path: 'money-market-funds',
        filters: ['Investor Class'],
        additionalPills: ['I Class']
    },
    {
        path: 'asset-allocation-funds',
        filters: ['Investor Class'],
        additionalPills: ['I Class']
    },
    {
        path: 'target-date-funds',
        filters: ['Investor Class'],
        additionalPills: ['I Class']
    },
    {
        path: 'iclass',
        filters: ['I Class'],
        additionalPills: ['Investor Class']
    },
    {
        path: 'iclass-shares',
        filters: ['I Class'],
        additionalPills: ['Investor Class']
    },
    {
        path: 'closed-funds',
        filters: ['Closed to New Investors']
    },
    {
        path: 'bond-funds',
        filters: ['Investor Class'],
        additionalPills: ['I Class']
    },
    {
        path: 'investor-class',
        filters: ['Investor Class'],
        additionalPills: ['I Class']
    },
    {
        path: 'open-to-new-investors',
        filters: ['Open to New Investors', 'Investor Class']
    },
    {
        path: 'bnfdns',
        filters: ['Investor Class']
    },
    {
        path: 'municipal-bond',
        filters: ['Investor Class']
    },
    {
        path: 'taxable-bond',
        filters: ['Investor Class']
    },
    {
        path: 'stfnds',
        filters: ['Investor Class']
    },
    {
        path: 'international-stocks',
        filters: ['Investor Class']
    },
    {
        path: 'sector-equity',
        filters: ['Investor Class']
    },
    {
        path: 'us-equity',
        filters: ['Investor Class']
    },
    {
        path: 'aaf',
        filters: ['Investor Class']
    },
    {
        path: 'alternative',
        filters: ['Investor Class']
    },
    {
        path: 'mmfnds',
        filters: ['Investor Class']
    },
    {
        path: 'tdf',
        filters: ['Investor Class']
    }
];

const riskFilter = [];
const fTypeFilter = [
    {
        path: 'bnfdns',
        filters: ['Bond Funds']
    },
    {
        path: 'municipal-bond',
        filters: ['Bond Funds']
    },
    {
        path: 'taxable-bond',
        filters: ['Bond Funds']
    },
    {
        path: 'stfnds',
        filters: ['Stock Funds']
    },
    {
        path: 'international-stocks',
        filters: ['Stock Funds']
    },
    {
        path: 'sector-equity',
        filters: ['Stock Funds']
    },
    {
        path: 'us-equity',
        filters: ['Stock Funds']
    },
    {
        path: 'aaf',
        filters: ['Allocation Funds']
    },
    {
        path: 'alternative',
        filters: ['Allocation Funds']
    },
    {
        path: 'mmfnds',
        filters: ['Money Market Funds']
    },
    {
        path: 'tdf',
        filters: ['Target Date Funds']
    }
];
const sfFilter = [
    {
        path: 'stock-funds',
        additionalPills: ['Select Funds']
    },
    {
        path: 'money-market-funds',
        additionalPills: ['Select Funds']
    },
    {
        path: 'asset-allocation-funds',
        additionalPills: ['Select Funds']
    },
    {
        path: 'bond-funds',
        additionalPills: ['Select Funds']
    },
    {
        path: 'iclass-shares',
        additionalPills: ['Select Funds']
    },
    {
        path: 'closed-funds',
        additionalPills: ['Select Funds']
    },
    {
        path: 'morningstar-4-and-5-star-rated-funds',
        additionalPills: ['Select Funds']
    }
];

const DEFAULT_PATH = 'investor-class';

const getPathParts = (loc, filterType) => {
    const res = {
        additionalPills: [],
        filters: [],
        ...filterType.find((f) => f.path === (loc || DEFAULT_PATH))
    };
    return { ...res, pills: [...res.filters, ...res.additionalPills] };
};

export const directLink = (loc) => getPathParts(loc, directPageFilters);
export const fTypeLink = (loc) => getPathParts(loc, fTypeFilter);
export const msDirectLink = (loc) => getPathParts(loc, mstarFilter);
export const sfDirectLink = (loc) => getPathParts(loc, sfFilter);
export const attrDirectlink = (loc) => getPathParts(loc, fundAttributeFilter);
export const riskDirectLink = (loc) => getPathParts(loc, riskFilter);
